import React, { Component } from "react";
import { FeatureDetails } from "../../components/features/FeatureDetails";
import { withRouter } from "react-router-dom";

class FeatureDetailsContainer extends Component {
  state = {
    feature: [],
    featureLoaded: false
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("features")
      .doc(this.props.featureId)
      .onSnapshot(doc => {
        if (doc.exists) {
          let feature = doc.data();
          feature["id"] = doc.id;
          this.setState({ feature: feature, featureLoaded: true });
        }
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
  };

  handleBackClick = () => {
    this.props.history.push("/features");
  };

  handleStatusChange = e => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.checked;
    window.firebase
      .firestore()
      .collection("features")
      .doc(this.props.featureId)
      .update(toUpdate);
  };

  render() {
    let isAdmin = this.props.admins.indexOf(this.props.user.uid) !== -1;

    return this.state.featureLoaded ? (
      <FeatureDetails
        feature={this.state.feature}
        user={this.props.user}
        userData={this.props.userData}
        handleBackClick={this.handleBackClick}
        isAdmin={isAdmin}
        handleStatusChange={this.handleStatusChange}
        admins={this.props.admins}
      />
    ) : (
      <div />
    );
  }
}

export default withRouter(FeatureDetailsContainer);
